"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiResolve = void 0;
const Api_hooks_1 = require("../hooks/Api.hooks");
// resolve api.fetch calls without using hooks
function apiResolve(request) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield request.response;
            const json = yield result.json();
            return result.ok ? { data: (0, Api_hooks_1.parseDateFields)(json) } : { error: json };
        }
        catch (error) {
            // ignore when request is aborted
            if (error instanceof Error && error.name === 'AbortError') {
                return {};
            }
            const { name, message } = error instanceof Error
                ? error
                : { name: 'Request Error', message: 'An error occurred.' };
            return {
                error: { error: name, message, statusCode: 500 }
            };
        }
    });
}
exports.apiResolve = apiResolve;
//# sourceMappingURL=apiResolve.js.map